/**
 * ElementGlyph — thin React wrapper over the domain glyph geometry
 * (`@flint/domain/garment/designs/flat-svg`): the marking drawn as the
 * actual feature (a pocket looks like a pocket). Geometry lives in domain
 * so the canvas, the pack screen, and the PDF stay pixel-identical.
 */
import {
  elementGlyphSvg,
  glyphBox,
  type FlatElementType,
  type GlyphBox,
} from "@flint/domain/garment/designs/flat-svg";

export { glyphBox };
export type { GlyphBox };

/** The glyph, centred on (0,0) — callers translate to the element's position. */
export function ElementGlyph({
  type,
  box,
}: {
  type: FlatElementType;
  box: GlyphBox;
}) {
  return (
    <g
      // Trusted static geometry from our own domain module — no user input.
      dangerouslySetInnerHTML={{ __html: elementGlyphSvg(type, box) }}
    />
  );
}
